import React, { useEffect, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Divider, TextField, Grid, Card, Button } from "@material-ui/core";
import { QRCode } from "react-qr-svg";
import UpgradeIcon from '@material-ui/icons/Update';
import ComputerIcon from '@material-ui/icons/Computer';
import Link from '@material-ui/icons/Link';
import { Base64 } from 'js-base64';


const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        justifyContent: "flex-start",
        backgroundColor: "#fafafc",
        paddingBottom: "0px!important",
    },
    cardContent: {
        width: "100%",
        margin: 0,
        padding: 30,
        color: "white!important",
        background: "white",
    },
    divider: {
        maxHeight: 2,
        marginTop: 20,
        marginBottom: 20,
        opacity: "0.1",
        background: "#868689",
        height: "1px!important",
        justifyContent: "center"
    },
    textField: {
        width: "100%",
        color: "black",
        marginTop: 30,
        textAlign: "center"
    },
    qrContainer: {
        width: "100%",
        padding: "0px!important",
        display: "flex",
    },
    qrStyle: {
        width: "70%",
        marginBottom: 60,
        alignSelf: "center"
    },
    updateButton: {
        marginTop: 20,
        alignItems: "center",
        width: "100%",
        height: 50,
        backgroundColor: "#ef4445",
        color: "#ffffff",
        fontWeight: "bold!important",
        textTransform: "none!important",
        opacity: 1,
        "&:hover": {
            cursor: "pointer",
            opacity: 0.8,
        },
    },
    linkButton: {
        marginBottom: 20,
        alignItems: "center",
        width: "100%",
        height: 50,
        backgroundColor: "#55c955",
        color: "#ffffff",
        fontWeight: "bold!important",
        textTransform: "none!important",
        "&:hover": {
            backgroundColor: "#88ea88!important",
            color: "#ffffff!important",
        },
    },
    gotoButton: {
        marginBottom: 20,
        alignItems: "center",
        width: "100%",
        height: 50,
        backgroundColor: "#def2fb",
        color: "#55c9f4",
        fontWeight: "bold!important",
        textTransform: "none!important",
        "&:hover": {
            cursor: "pointer",
            backgroundColor: "#55c9f4!important",
            color: "#ffffff!important",
        },
    },
    contentSection: {
        flexGrow: 1,
        margin: 0,
        padding: 0,
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "column",
    },
    stepsSection: {
        flex: "10",
    },
    stepsSectionTwo: {
        flexGrow: "1",
        flex: "1",
    },
    leftContent: {
        minWidth: 200,
        flex: "1",
        alignItems: "center!important",
        justifyContent: "center!important",
    },
    rightContent: {
        minWidth: 200,
        flex: "1",
        color: "black",
        alignItems: "center!important",
        justifyContent: "center!important",
    },
}));


const ControlPointManageQR = ({
    controlPoint,
    onUpdateQRToken,
    onCopiedKioskLinkToClipboard
}) => {
    const classes = useStyles();
    const [localControlPoint, setControlPoint] = React.useState(controlPoint);

    React.useEffect(() => {
        if (controlPoint) {
            setControlPoint(controlPoint);
        }
    }, [controlPoint]);

    function onCopyKioskLink() {
        const url = getKioskLink();

        const el = document.createElement("textarea");
        el.value = url;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        onCopiedKioskLinkToClipboard();
    }


    function getKioskLink() {
        const encode = Base64.encode(controlPoint.key);
        return window.location.protocol + "//" + window.location.host + "/cp/" + encode
    }

    return (
        <div className={classes.root}>
            <Card className={classes.cardContent}>
                <Grid container className={classes.contentSection}>
                    <Grid item xs={12} md={12} className={classes.stepsSection}>
                        <Grid container className={classes.stepsSectionTwo}>
                            <Grid item md={12} xs={12} lg={6} className={classes.leftContent}>
                                <div className={classes.qrContainer}>
                                    {
                                        localControlPoint && localControlPoint.qrcode ?

                                            <QRCode
                                                id="qr-code"
                                                bgColor="#FFFFFF"
                                                fgColor="#000000"
                                                level="Q"
                                                className={classes.qrStyle}
                                                value={localControlPoint.qrcode}
                                            /> : <div></div>
                                    }
                                </div>

                            </Grid>
                            <Grid item md={12} xs={12} lg={6} className={classes.rightContent}>
                                <Button
                                    className={classes.linkButton}
                                    onClick={() => window.open(getKioskLink(), '_blank')}
                                >
                                    <ComputerIcon style={{ marginRight: 10 }} />
                                    Ir a la plataforma de Self-Check-In
                                </Button>
                                <Button
                                    className={classes.gotoButton}
                                    onClick={onCopyKioskLink}
                                >
                                    <Link style={{ marginRight: 10 }} />
                                    Copiar link al Self-Check-In
                                </Button>
                                <Divider className={classes.divider} />

                                <Grid item xs={12} md={12}>
                                </Grid>
                                <TextField
                                    id="token"
                                    label="Password"
                                    disabled={true}
                                    className={classes.textField}
                                    variant="outlined"
                                    onChange={() => { }}
                                    value={
                                        localControlPoint && localControlPoint.token ? localControlPoint.token : "-"
                                    }
                                />
                                <Button
                                    className={classes.updateButton}
                                    onClick={onUpdateQRToken}
                                >
                                    <UpgradeIcon style={{ marginRight: 10 }} />
                                    Generar nuevo password
                                </Button>

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Card>
        </div>
    );
};


export default (ControlPointManageQR);
